import moment from "moment";

export const stepperHeading = "Create a Campaign with 5 easy steps!"
export const steps = ['GOAL', 'TARGET CUSTOMERS', 'PRODUCT DETAILS', 'BANNER', 'ADD CALLOUT DETAILS'];

const timeFrom = new Date()
timeFrom.setHours(0, 0, 0, 0)
const timeTo = new Date()
timeTo.setHours(23, 59, 0, 0)
const defaultStep1State = {
    goal: "",
    campaignName: "",
    // campaignOwner: "",
    // campaignType: "",
    date: {
        from: null,
        to: null,
        __noNesting: true
    },
    time: {
        from: moment(timeFrom),
        to: moment(timeTo),
        __noNesting: true
    },
}

const defaultStep1ValidObj = { ...defaultStep1State }
defaultStep1ValidObj.time = {
    from: true,
    to: true
}

const defaultStep2State = {
    isExclude: false,
    include: {
        operator: "AND",
        attributes: [{}]
    },
    exclude: {
        operator: "AND",
        attributes: [{}]
    },
}

const { isExclude, ...defaultStep2ValidObj } = defaultStep2State
const validObjStep = {
    operator: true,
    attributes: false
}
defaultStep2ValidObj.include = validObjStep
defaultStep2ValidObj.exclude = { ...validObjStep, attributes: true }

// const defaultStep3State = {
//     include: {
//         operator: "AND",
//         attributes: [{}]
//     },
//     totalProducts: "" 
// }

//For V0
const defaultStep3State = {
    operator: 'AND',
    attributes: [{}]
}

// const defaultStep3ValidObj = {
//     include: validObjStep,
//     totalProducts: false
// }

//For V0

const defaultStep3ValidObj = validObjStep;

const defaultStep4StateV0 = {
    bannerInput:"",
    jpins:"",
    comment:"",
    bannerLink: "",
    url: "",
}

const defaultStep5State = {
    plvCallOut: "",
    score: ""
}

const defaultStep4State = {
    channels: [],
    displayJpins: "",
    bannerCallout: "",
}

const defaultIsStepValid = {
    [steps[0]]: defaultStep1ValidObj,
    [steps[1]]: defaultStep2ValidObj,
    [steps[2]]: defaultStep3ValidObj,
    [steps[3]]: defaultStep4StateV0,
    [steps[4]]: defaultStep5State,
    __noNesting: true
}

export const createCampaignQuery = {
    customer:"CUSTOMER",
    product:"PRODUCT"
}

export const defaults = {
    step1State: defaultStep1State,
    step2State: defaultStep2State,
    step3State: defaultStep3State,
    step4State: defaultStep4StateV0,
    step5State: defaultStep5State,
    isStepValid: defaultIsStepValid,
}